export default "__VITE_ASSET__BGNCFM9s__"